export enum BusinessType {
  AGRICULTURE = 'AGRICULTURE',
  ARTS = 'ARTS',
  AUTOMOTIVE_AND_VEHICLE = 'AUTOMOTIVE_AND_VEHICLE',
  CHILDCARE_AND_HEALTHCARE = 'CHILDCARE_AND_HEALTHCARE',
  CRYPTO_PAYMENT_PROCESSING = 'CRYPTO_PAYMENT_PROCESSING',
  CRYPTO_SERVICES = 'CRYPTO_SERVICES',
  DIGITAL_GOODS = 'DIGITAL_GOODS',
  ELECTRONICS_AND_ELECTRICITY = 'ELECTRONICS_AND_ELECTRICITY',
  ENERGY = 'ENERGY',
  ENTERTAINMENT_AND_BROADCASTING = 'ENTERTAINMENT_AND_BROADCASTING',
  FINANCIAL_SERVICES = 'FINANCIAL_SERVICES',
  FOOD_BEVERAGE_AND_TOBACCO = 'FOOD_BEVERAGE_AND_TOBACCO',
  GOVERNMENTAL_AND_NON_PROFIT = 'GOVERNMENTAL_AND_NON_PROFIT',
  HOME_AND_GARDEN = 'HOME_AND_GARDEN',
  INFORMATION_AND_COMMUNICATION = 'INFORMATION_AND_COMMUNICATION',
  IT_SERVICES = 'IT_SERVICES',
  MINING_AND_QUARRYING = 'MINING_AND_QUARRYING',
  REAL_ESTATE_AND_HOUSING = 'REAL_ESTATE_AND_HOUSING',
  RETAIL_AND_WHOLESALE = 'RETAIL_AND_WHOLESALE',
  SERVICES = 'SERVICES',
  SHIPPING = 'SHIPPING',
  TOURISM = 'TOURISM',
  TRAVEL_AND_TRANSPORTATION = 'TRAVEL_AND_TRANSPORTATION',
  WEAPONS = 'WEAPONS',
  OTHER = 'OTHER',
}

export const BUSINESS_TYPES = Object.values(BusinessType);

export enum ControlType {
  INDIVIDUAL = 'INDIVIDUAL',
  ALGORITHM = 'ALGORITHM',
}

export const CONTROL_TYPES = Object.values(ControlType);

export enum OrganisationType {
  CREDIT_INSTITUTION = 'CREDIT_INSTITUTION', // A credit institution
  INVESTMENT_FIRM = 'INVESTMENT_FIRM', // An investment firm
  OTHER_AUTHORISED_OR_REGULATED_FINANCIAL_INSTITUTION = 'OTHER_AUTHORISED_OR_REGULATED_FINANCIAL_INSTITUTION', // Any other authorised or regulated financial institution
  INSURANCE_COMPANY = 'INSURANCE_COMPANY', // An insurance company
  COLLECTIVE_INVESTMENT_SCHEME = 'COLLECTIVE_INVESTMENT_SCHEME', // A collective investment scheme or the management company of such a scheme
  PENSION_FUND = 'PENSION_FUND', // A pension fund or the management company of a pension fund
  COMMODITY_DEALER = 'COMMODITY_DEALER', // A commodity or commodity derivatives dealer
  OTHER_INSTITUTIONAL_INVESTOR = 'OTHER_INSTITUTIONAL_INVESTOR', // Other institutional investors whose main activity is to invest in financial instruments, including entities dedicated to the securitisation of assets or other financing transactions
  GOVERNMENT = 'GOVERNMENT', // National and regional governments, including public bodies that manage public debt at national or regional level
  CENTRAL_BANK = 'CENTRAL_BANK', // Central bank
  NONE_OF_THE_ABOVE = 'NONE_OF_THE_ABOVE', // None of the above
}

export const ORGANISATION_TYPES = Object.values(OrganisationType);

export const ORGANISATION_TYPES_REGULATED_FINANCIAL_SERVICES = [
  OrganisationType.CREDIT_INSTITUTION,
  OrganisationType.INVESTMENT_FIRM,
  OrganisationType.OTHER_AUTHORISED_OR_REGULATED_FINANCIAL_INSTITUTION,
  OrganisationType.INSURANCE_COMPANY,
] as const;

export enum FinancialOrganisationType {
  INVESTMENT_BANK = 'INVESTMENT_BANK', // An Investment Bank trading proprietary funds / capital
  PROPRIETARY_TRADING_FIRM = 'PROPRIETARY_TRADING_FIRM', // A Proprietary Trading Firm
  MARKET_MAKER = 'MARKET_MAKER', // A Market Maker
  NONE_OF_THE_ABOVE = 'NONE_OF_THE_ABOVE', // None of the above
}

export type OrganisationTypeRegulatedFinancialServices = (typeof ORGANISATION_TYPES_REGULATED_FINANCIAL_SERVICES)[number];

export const FINANCIAL_ORGANISATION_TYPES = Object.values(FinancialOrganisationType);

export enum EmirClassification {
  FINANCIAL_COUNTERPARTY = 'F', // Financial Counterparty
  NON_FINANCIAL_COUNTERPARTY = 'N', // Non-financial Counterparty
  OTHER = 'O', // Other
}

export const EMIR_CLASSIFICATIONS = Object.values(EmirClassification);

export enum EsmaClassification {
  CREDIT_INSTITUTION = 'CDTI', // Credit institution (CDTI)
  INVESTMENT_FIRM = 'INVF', // Investment firm (INVF)
  INSURANCE_UNDERTAKING = 'INUN', // Insurance undertaking (INUN)
  UCIT_FUNDS = 'UCIT', // Undertakings for Collective Investment in Transferable Securities (UCIT) funds
  PENSION_FUNDS = 'ORPI', // Pension funds (ORPI)
  ALTERNATIVE_INVESTMENT_FUNDS = 'AIFD', // Alternative Investment Funds (AIFD)
  CENTRAL_SECURITIES_DEPOSITORY = 'CSDS', // Central Securities Depository (CSDS)
  NON_FINANCIAL_COUNTERPARTIES = 'NFCs', // Non-financial counterparties (NFCs)
}

export const ESMA_CLASSIFICATIONS = Object.values(EsmaClassification);

export enum NaceClassification {
  AGRICULTURE_FORESTRY_FISHING = 'A', // Agriculture, forestry and fishing
  MINING_QUARRYING = 'B', // Mining and quarrying
  MANUFACTURING = 'C', // Manufacturing
  ELECTRICITY_GAS_STEAM_AIR_CONDITIONING = 'D', // Electricity, gas, steam and air conditioning supply
  WATER_SUPPLY_SEWERAGE_WASTE_MANAGEMENT = 'E', // Water supply, sewerage, waste management and remediation activities
  CONSTRUCTION = 'F', // Construction
  WHOLESALE_RETAIL_TRADE = 'G', // Wholesale and retail trade; repair of motor vehicles and motorcycles
  TRANSPORTATION_STORAGE = 'H', // Transportation and storage
  ACCOMMODATION_FOOD_SERVICE = 'I', // Accommodation and food service activities
  INFORMATION_COMMUNICATION = 'J', // Information and communication
  FINANCIAL_INSURANCE_ACTIVITIES = 'K', // Financial and insurance activities
  REAL_ESTATE_ACTIVITIES = 'L', // Real estate activities
  PROFESSIONAL_SCIENTIFIC_TECHNICAL = 'M', // Professional, scientific and technical activities
  ADMINISTRATIVE_SUPPORT_SERVICE = 'N', // Administrative and support service activities
  PUBLIC_ADMINISTRATION_DEFENCE = 'O', // Public administration and defence; compulsory social security
  EDUCATION = 'P', // Education
  HUMAN_HEALTH_SOCIAL_WORK = 'Q', // Human health and social work activities
  ARTS_ENTERTAINMENT_RECREATION = 'R', // Arts, entertainment and recreation
  OTHER_SERVICE_ACTIVITIES = 'S', // Other service activities
  HOUSEHOLDS_AS_EMPLOYERS = 'T', // Activities of households as employers; undifferentiated goods- and services-producing activities of households for own use
  EXTRATERRITORIAL_ORGANISATIONS = 'U', // Activities of extraterritorial organisations and bodies
}

export const NACE_CLASSIFICATIONS = Object.values(NaceClassification);

export enum EmirThreshold {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
}

export const EMIR_THRESHOLDS = Object.values(EmirThreshold);
